"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const utilities_1 = require("../../utilities");
const polished_1 = require("polished");
const InputSmarttag_1 = tslib_1.__importDefault(require("../InputSmarttag"));
const styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
const SmarttagTags_1 = tslib_1.__importDefault(require("../SmarttagTags"));
const Wrapper = styled_components_1.default.div ``;
const SmarttagTagsWrapper = (0, styled_components_1.default)('div') `
  margin-top: ${(0, polished_1.rem)(10)};
`;
const C = (_a) => {
    var { readOnly = false, creatable = true, disabled = false, value = [], onChange = utilities_1.emptyFn, availableSmarttags = [], getSmarttagsKeys = null, getSmarttagsValues = null, getSmarttagsByFts = null } = _a, restProps = tslib_1.__rest(_a, ["readOnly", "creatable", "disabled", "value", "onChange", "availableSmarttags", "getSmarttagsKeys", "getSmarttagsValues", "getSmarttagsByFts"]);
    return (React.createElement(Wrapper, null,
        !readOnly && (React.createElement(InputSmarttag_1.default, Object.assign({ creatable: creatable, disabled: disabled, onAdd: (newSmarttag) => {
                let smarttags = value ? [...value] : [];
                const smarttagIndex = smarttags.findIndex(stag => stag.key === newSmarttag.key);
                if (smarttagIndex === -1) {
                    smarttags.push(newSmarttag);
                }
                else {
                    const smarttag = Object.assign({}, smarttags[smarttagIndex]);
                    const idx = smarttag.values.findIndex((val) => val.key === newSmarttag.values[0].key);
                    if (idx === -1) {
                        smarttag.values = [...smarttag.values, newSmarttag.values[0]];
                    }
                    smarttags = [
                        ...smarttags.slice(0, smarttagIndex),
                        smarttag,
                        ...smarttags.slice(smarttagIndex + 1),
                    ];
                }
                onChange([...smarttags]);
            }, availableSmarttags: availableSmarttags, getSmarttagsKeys: getSmarttagsKeys, getSmarttagsValues: getSmarttagsValues, getSmarttagsByFts: getSmarttagsByFts, readOnly: readOnly }, restProps))),
        React.createElement(SmarttagTagsWrapper, null,
            React.createElement(SmarttagTags_1.default, Object.assign({}, (!readOnly && {
                onChange: newSmarttags => {
                    onChange(newSmarttags);
                },
            }), { items: value || [], disabled: disabled })))));
};
exports.default = C;
